<script setup lang="ts">
import lodashPick from 'lodash-es/pick';

import type { CountryField, CountryOption } from '~/types/signup/country.type';

const model = defineModel<CountryField | undefined>({ required: true });

const { countries } = useCountries();

const { tt } = useTypedI18n();

const inputModel = computed<CountryOption | undefined>({
    get() {
        return countries.value.find(c => c.countryCode === model.value?.countryCode);
    },
    set(newValue: CountryOption | undefined) {
        model.value = newValue && lodashPick(newValue, ['countryCode']);
    },
});
</script>

<template>
    <USelectMenu v-model="inputModel" :items="countries" :search-input="{ placeholder: tt('common.searchPlaceholder') }">
        <template #empty="{ searchTerm: query }">
            <span>{{ tt('common.searchNoResults', { query }) }}</span>
        </template>
    </USelectMenu>
</template>
